import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToHash from "./components/common/ScrollToHash";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Hero from "./components/sections/Hero";
import Nav from "./components/layout/Nav";
import About from "./components/sections/About";
import Contact from "./components/sections/Contact";
import Bliss from "./pages/Bliss";
import Work from "./pages/Work";
import Capabilities from "./pages/Capabilities";
import ContactPage from "./pages/ContactPage";

import "./styles/App.css";

function Home() {
  return (
    <>
      <Hero />
      <Nav />
      <About />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToHash />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/capabilities" element={<Capabilities />} />
        <Route path="/bliss" element={<Bliss />} />
        <Route path="/blog" element={<Navigate to="/bliss" replace />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
